
main.cookie = (function () {
    var limitIE = 10;
    var bar = document.getElementsByClassName('js-cookie-bar')[0];
    var acceptBtn = bar.getElementsByClassName('js-cookie-accept')[0];
    var browserWarning = document.getElementsByClassName('js-browserwarning-bar')[0];
    var cookie;

    var init = function () {

        if (main.utils.isIe() && browserWarning !== null) {
            var ieVersion = main.utils.getIeVersion();
            if (ieVersion <= limitIE) {
                main.utils.removeClass(browserWarning, 'u-hidden');
            }
        }

        cookie = main.utils.readCookie('cookiebar');

        if (cookie !== null) { return; }

        main.utils.removeClass(bar, 'u-hidden');

        _eventHandler();
    };

    var _eventHandler = function () {
        acceptBtn.addEventListener('click', _setCookie);
        bar.setAttribute('aria-hidden', 'true');
    };

    var _setCookie = function () {
        main.utils.addClass(bar, 'is-accepted');
        main.utils.createCookie('cookiebar', 'hide', 365);

        return false;
    };

    return {
        init: init
    };

})();
